<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('can_manage_users')" id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
        <div class="page-header-top-container">
          <div class="page-name">Users</div>
          <button
                  type="submit"
                  v-on:click.prevent="addUser()"
                  class="btn btn-primary waves-effect pull-right"
          >Add</button>
        </div>

        <!--Loading-->
        <!--<div class="loading-container">
                    <div class="loading">
                        <img src="/static/images/loading.gif">
                    </div>
        </div>-->
        <!--Loading-->

        <!--page content-->
        <div class="admin-page-content">
            <div class="app-filter-good-table-container">
            <vue-good-table
                    ref="listUser"
                    mode="remote"
                    title="User"
                    @on-page-change="onPageChange"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                }"
                    :pagination-options="{
                enabled: true,
                mode: 'pages',
                pageLabel: 'Page',
                position: 'bottom',
                perPage: serverParams.perPage,
                setCurrentPage: serverParams.setCurrentPage,
                perPageDropdown: [25, 50, 100, 200 ,500],
                dropdownAllowAll: false,
                }"
                    :search-options="{
                enabled: false,
                }"
            >

                <!-- Custome Pagination -->
                <template slot="pagination-bottom" slot-scope="props">
                    <div class="vgt-wrap__footer crm" v-if="totalRecords > 0">
                        <div  class="row">
                            <div class="col-sm-12 col-md-2 PerPage">
                                <v-select title="Select Per Page"
                                          v-model="serverParams.perPage"
                                          @change="changedValueTask"
                                          @input="changedValueTaskCustomPerPageTask()"
                                          name="customPerPage"
                                          id="customPerPage"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="serverParams.perPageDropdown"
                                          placeholder="Select Per Page">
                                </v-select>
                            </div>
                            <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                            </div>
                            <div class="col-sm-12 col-md-6 Pagination">
                                <ul class="pagination">
                                    <li class="FirstPage" title="First Page">
                                        <template v-if="Number(serverParams.page) == 1">
                                            <a class="page-link" href="javascript:void(0)">1</a>
                                        </template>
                                        <template v-else>
                                            <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                        </template>
                                    </li>
                                    <li class="page-item PreviousPage" title="Previous Page">
                                        <template v-if="Number(serverParams.page) == 1">
                                            <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                        </template>
                                        <template v-else>
                                            <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                        </template>
                                    </li>
                                    <!--New Implementation-->
                                    <template v-if="pageNumberListTask() < displayPageTask">
                                        <template v-for="(n, index) in pageNumberListTask()">
                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                <a class="page-link" href="javascript:void(0)">
                                                    {{n}}
                                                </a>
                                            </li>
                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                <a class="page-link" href="javascript:void(0)">
                                                    {{n}}
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <!--End New Implementation-->
                                        <template v-if="Number(serverParams.page) <= pageCompareTask">
                                            <template v-for="(n, index) in displayPageTask">
                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                        <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                            <template v-for="(n, index) in pageNumberListTask()">
                                                <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                                <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                    <a class="page-link" href="javascript:void(0)">
                                                        {{n}}
                                                    </a>
                                                </li>
                                            </template>
                                        </template>
                                    </template>
                                    <li class="page-item NextPage" title="Next Page">
                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                            <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                        </template>
                                        <template v-else>
                                            <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                        </template>
                                    </li>
                                    <li class="LastPage" title="Last Page">
                                        <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                            <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                        </template>
                                        <template v-else>
                                            <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                        </template>
                                    </li>
                                </ul>
                            </div>
                            <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                <p class="pageJumpLabel">Page : </p>
                            </div>
                            <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                            </div>
                        </div>
                    </div>
                </template>
                <!-- End Custome Pagination -->

                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                <div :key="key">
                    <div v-if="props.column.field == 'action'">
                    <!--class="btn btn-xs btn-primary"-->
                    <router-link
                            class="btn edit-btn-vvg waves-effect"
                            title="Edit User"
                            v-bind:to="{name: 'UpdateUser',params:{id:props.row.id}}"
                    >
                        <i class="fa fa-pencil" aria-hidden="true"></i>
                    </router-link>
                    <button
                            v-on:click="deleteUser(props.row.id)"
                            class="btn edit-btn-vvg waves-effect fa fa-trash"
                            title="Delete User"
                    >
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>

                    <router-link
                            v-if="permissionsArray.includes('manage_pay_plans')"
                            class="btn edit-btn-vvg waves-effect"
                            title="Edit User"
                            v-bind:to="{name: 'ManagePayPlans',params:{id:props.row.id}}"
                    >
                        <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </router-link>

                    <button
                            class="btn edit-btn-vvg waves-effect fa fa-trash"
                    >
                      <i v-on:click="changeStatusUser(props.row.id)" title="Active" v-show="props.row.status === 'active'" class="fa fa-check" aria-hidden="true"></i>
                      <i v-on:click="changeStatusUser(props.row.id)" title="Inactive" v-show="props.row.status === 'inactive'" class="fal fa-ban" aria-hidden="true"></i>
                    </button>

                  </div>
                  <div v-else>{{props.formattedRow[props.column.field]}}</div>
                </div>
                </template>
                <div slot="selected-row-actions" slot-scope="computed">
                {{computed.selectedRows}}
                <button
                        v-on:click="deleteUser()"
                        class="btn btn-success"
                        title="Mail"
                >Delete User</button>
                </div>
            </vue-good-table>
            </div>
        </div>
        <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';

    Vue.use(VueGoodTable);
    export default {
        name: "ListUser",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                roleId: 0,
                firstLoad: 0,
                columns: [
                    {
                        label: "First Name",
                        field: "first_name",

                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "First Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Last Name",
                        field: "last_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Last Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Email",
                        field: "username",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Email", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Dayforce Id",
                        field: "emp_id",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Dayforce Id", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Role",
                        field: "role_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Role", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 25,
                    sort: {
                        field: "id",
                        type: "asc"
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,
                permissionsArray: ['can_manage_users'],

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
            };
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "listuser");
        },
        mounted: function() {
            //self.getUserRole();
            self.getUserPermissions();

            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);

            self.loadUser();
        },

        methods: {
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadUser();
            },
            changedValueTask: function (value) {

            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadUser();
            },
            changeStatusUser : function(userId) {
                var userArr = [];
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    }
                };

                var fields = {
                    user_id: userId
                };

                self.$swal({
                        title: "Are you sure?",
                        text: "You want to change the status",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes Change it!",
                        cancelButtonText: "No, Keep it!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("/user/change-user-status", fields, config)
                                .then(function(response) {
                                    self.loadUser();
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                        }

                    });
            },
            addUser: function() {
                self.$router.push("/add-user");
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadUser();
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadUser();
                }
            },

            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "first_name";
                    field: "last_name";
                    field: "username";
                    field: "emp_id";
                    field: "role_name";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.first_name ||
                    filters.last_name ||
                    filters.username ||
                    filters.emp_id ||
                    filters.role_name
                ) {
                    self.loadUser();
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listUser"].selectedRows.length;
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadUser();
            },

            deleteUser: function(id) {
                var userArr = [];
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    }
                };

                if (id) {
                    userArr.push(id);
                } else {
                    var selectedUser = this.$refs["listUser"].selectedRows;
                    for (var i = 0; i < selectedUser.length; i++) {
                        userArr.push(this.$refs["listUser"].selectedRows[i].id);
                    }
                }
                var fields = {
                    deleteArr: userArr
                };

                self.$swal({
                        title: "Are you sure?",
                        text: "You can't revert your action",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonText: "Yes Delete it!",
                        cancelButtonText: "No, Keep it!",
                        showCloseButton: true,
                        showLoaderOnConfirm: true
                    })
                    .then(result => {
                        if (result.value) {
                            HTTP.post("/user/delete-user", fields, config)
                                .then(function(response) {
                                    self.loadUser();
                                })
                                .catch(function(err) {
                                    if (err.response.status == 0) {
                                        self.error = "Remote server can not be reachable";
                                    } else {
                                        //redirect to login page if user not authenticated
                                        if (err.response.status == 401) {
                                            //clear previous data
                                            localStorage.removeItem("user_obj");
                                            localStorage.removeItem("api_token");
                                            localStorage.removeItem("profile_image");
                                            //self.$router.push("/login");
                                            //EventBus.$emit("logged-in", true, "", "");
                                        }
                                    }
                                });
                            self.$swal(
                                "Deleted",
                                "You successfully deleted user(s)",
                                "success"
                            );
                        } else {
                            self.$swal("Cancelled", "Your file is still intact", "info");
                        }
                    });
            },

            loadUser: function() {
                self.firstLoad = 1;
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {
                        Authorization:"Bearer " + localStorage.getItem("api_token")
                    },
                    params : {
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort
                    }
                };
                /*var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    messageData: self.message,
                    sort: self.serverParams.sort
                };*/
                HTTP.get("/user/list-user", config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            self.rows = response.data.content.row;
                            self.totalRecords = response.data.content.totalRecords;
                            // $('.loading-container').hide();
                        }
                        self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                    })
                    .catch(function(err) {
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };

    EventBus.$on("role", function(isLogin, roleId, roleName) {
        if (typeof self != "undefined") {
            self.roleId = roleId;
        }
    });

    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>


// WEBPACK FOOTER //
// src/components/User/ListUser.vue